/*
 * WaWiAuftragAppQuery.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-06 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { gql } from 'graphql-tag'

import { AUFTRAG_FRAGMENT } from '../../fragments'

// Liste aller Aufträge

export const AUFTRAG_LIST_QUERY = gql`
  query AlleAuftraegePages($cursor: String) {
    nodes: hwAuftragPages(after: $cursor, filter: { erledigt: { eq: false } }) {
      edges {
        cursor
        node {
          ...auftragFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AUFTRAG_FRAGMENT}
`
export const AUFTRAGBELEGE_QUERY = gql`
  query AuftragBelege($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      id
      belege {
        id
        designator
        belegart
        belegdatum
        name
        raw
      }
    }
  }
`
